import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { getActionViewFieldId } from '../actionView.adapters';
import {
    ActionViewSearchRequest,
    ActionViewUiColumn,
    TaskActionViewOrganizeBy,
    TaskActionViewThatAreOption,
} from '../actionView.models';

interface ActionViewGroupOption {
    id: number;
    name: string;
}

@Component({
    selector: 'action-view-overview-options',
    templateUrl: './actionViewOverviewOptions.component.html',
    standalone: false,
})
export class ActionViewOverviewOptionsComponent implements OnChanges {
    @Input({ required: true }) criteria: ActionViewSearchRequest;
    @Input() filterColumns: ActionViewUiColumn[] = [];
    @Input() loading: boolean = false;
    @Output() criteriaChange = new EventEmitter<ActionViewSearchRequest>();

    readonly organizeByItems = [
        { id: TaskActionViewOrganizeBy.Urgency, name: 'Urgency' },
        { id: TaskActionViewOrganizeBy.DueDate, name: 'Due Date Range' },
        { id: TaskActionViewOrganizeBy.LastActivityDate, name: 'Last Action Date Range' },
    ];
    readonly thatAre = TaskActionViewThatAreOption;

    groupByOptions: ActionViewGroupOption[] = [];
    selectedGroupBy: number | null = null;

    ngOnChanges(): void {
        const columns = [...this.filterColumns, ...this.criteria.taskOutputColumns];
        const seen = new Set<number>();
        this.groupByOptions = columns
            .filter((column) => column.canGroupTaskActionView)
            .map((column) => ({
                id: getActionViewFieldId(column),
                name: column.resultColumnName ?? column.displayName ?? `Field ${getActionViewFieldId(column)}`,
            }))
            .filter((column) => {
                if (seen.has(column.id)) {
                    return false;
                }
                seen.add(column.id);
                return true;
            })
            .sort((left, right) => left.name.localeCompare(right.name));
        this.selectedGroupBy = this.criteria.groupBy.find((fieldId) => fieldId !== 10001) ?? null;
    }

    setOrganizeBy(organizeBy: TaskActionViewOrganizeBy): void {
        this.update({ organizeBy: Number(organizeBy) as TaskActionViewOrganizeBy });
    }

    setGroupBy(groupBy: number | null): void {
        const selected = groupBy === null || groupBy === undefined || groupBy === 0 ? [] : [Number(groupBy)];
        this.selectedGroupBy = selected[0] ?? null;
        this.update({ groupBy: selected });
    }

    setBoolean(property: 'showMostPressingTasks' | 'calculateReadyAndNotReady' | 'showTotals', value: boolean): void {
        this.update({ [property]: value });
    }

    private update(changes: Partial<ActionViewSearchRequest>): void {
        this.criteriaChange.emit({ ...this.criteria, ...changes });
    }
}
